export default "__VITE_ASSET__5Dhfu_dg__"